"use strict";

var curry = require("./curry.js");

module.exports = curry(function has(k, obj) {
  return !!(obj && obj.hasOwnProperty(k));
});